module.exports = __webpack_public_path__ + "static/media/ASR-BNB.c23aa78e.svg";